<template>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-xl-4 col-lg-3">
        <div class="logo_footer">
          <!-- <img src="~@/assets/logo.png" alt=""> -->
          <template v-if="get_footer.images">
       <router-link to="/" class="logo" v-for="image in get_footer.images" :key="image.id">
     <span class="sp_b">LADE</span>
     <img  :src="image.url" alt="">
     </router-link>
    </template>
          <!-- <template v-if="get_footer.images">
             <img  :src="get_footer.images[0].url" alt="">
          </template> -->
          
         <div class="desc_foot" v-html="get_footer.subscribe"></div>
          <div class="social_footer">
             <template v-for="social in get_footer.socials">
               <a :href="social.link" target="_black" v-if="social.link!=''" :key="social.id"><i :class='`bx bxl-${social.icon}`'></i></a>
          </template>
           
            <!-- <a href="#"><i class='bx bxl-instagram-alt' ></i></a>
            <a href="#"><i class='bx bxl-whatsapp' ></i></a>
            <a href="#"><i class='bx bxl-tiktok' ></i></a> -->
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3">
        <div class="site_info">
          <h1>KONTAKTINFO</h1>
           <template v-for="info in get_footer.info">
            <template v-if="info.type=='text'">
                <a :key="info.id" >{{info.value}}</a>
            </template>
            <template v-else>
              <template v-if="info.key=='email'">
                  <a :key="info.id" :href="`mailto:${info.value}`" >{{info.value}}</a>
              </template>
              <template v-else-if="info.key=='phone'">
                 <a :key="info.id" :href="`tel:${info.value}`" >{{info.value}}</a>
              </template>
              <template v-else>
                 <a :key="info.id" :href="info.icon" >{{info.value}}</a>
              </template>
            </template>
          </template>
          <!-- <a class="two_line" href="#" target="_black" >Tempevegen 31, 7037 Trondheim</a>
          <a href="#">46825999</a>
          <a href="#">post@bpst.no</a> -->
        </div>
      </div>
      <div class="col-xl-2 col-lg-3">
        <!-- services -->
        <div class="site_links title_links service_footer" v-if="get_footer.categories">
          <h1>TJENESTER</h1>
          <template v-for="serv in get_footer.categories.slice(0,4)">
             <router-link :key="serv.id" :to="`/service/${serv.id}`">{{serv.title}}</router-link>
          </template>
         <!-- =====
          <a href="#">Utvendig Vask</a>
          <a href="#">Laer & Skinn</a>
          <a href="#">Bilglass</a>
          <a href="#">Xpel</a> -->
        </div>
      </div>
      <div class="col-xl-3 col-lg-3">
         <div class="site_links service_footer" v-if="get_footer.categories">
          <template v-for="serv in get_footer.categories.slice(4,12)">
             <router-link :key="serv.id" :to="`/service/${serv.id}`">{{serv.title}}</router-link>
          </template>
          <!-- <a href="#">Lakkering</a>
          <a href="#">Innvendig Vask</a>
          <a href="#">Keramisk Lakkbeskyttelse</a>
          <a href="#">Gullpakke</a>
          <a href="#">Dekorfjerining</a>
          <a href="#">Age Stop</a>
          <a href="#">Sliping Av Frontlykter</a> -->
        </div>
      </div>
    </div>
  </div>
  <div class="copy">
          <span>Copyright © 2023 {{get_setting.name}} | Powered by <strong>Remak As</strong></span>
        </div>
</footer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "footerApp",
  computed:{
    ...mapGetters({
        get_footer:'get_footer',
        get_setting:'get_setting'
    })
    } ,
     methods:{
    ...mapActions({
       footer_api:'footer_api',
    }),
    },
    mounted(){
      this.footer_api();
    }
  
  
}
</script>
<style lang="scss" scoped>
footer{
  padding: 120px 0px 0px 0px;
  .row{
    justify-content: space-between;
  }
  .logo_footer{
      .sp_b{
    position: absolute;
    font-size: 14px;
    transform: rotate(332deg);
    left: 35px;
    top: 14px;
    font-weight: 500;
    color: #fff;
     font-family: "Oswald", sans-serif;
  }
    img{
      width: 200px;
    height: 90px;
    object-fit: contain;
    }
    .desc_foot{
      padding-top: 14px;
       font-size: 14px;
      color: #d8d8d8;
      font-weight: 300;
       font-family: 'Roboto', sans-serif;
    }
    p{
      font-size: 14px;
      color: #d8d8d8;
      font-weight: 300;
       font-family: 'Roboto', sans-serif;
    }
    .social_footer{
       display: flex;
      a{
        color: white;
        width: 35px;
        height: 35px;
        font-size: 25px;
        // background-color: #d8d8d8;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
      }
    }
  }
  .title_links{
    text-align: right;
  }
  .site_info , .site_links{
    h1{
          font-size: 1.5rem;
          font-family: 'Oswald',sans-serif;
          font-weight: 400;
          text-transform: uppercase;
              margin-bottom: 1em;
    line-height: 1.5;
    color: white;
    }
    a{
      font-size: 1rem;
      color: #d8d8d8;
      font-weight: 300;
       font-family: 'Roboto', sans-serif;
       display: block;
       line-height: 25px;
       margin-bottom: 0.3rem;
    }
    a.two_line{
      padding-right: 0px;
    }
  }
  .copy{
    font-size: 13px;
    text-align: center;
    padding: 80px 0px 25px 0px;
    color: #d8d8d8;
    font-weight: 300;
  }
.service_footer , .logo_footer{
  a{
    transition: 0.3s ease-in-out;
    &:hover{
      color: var(--active_color);
    }
  }
}
}



// STYLE MEDIA QUERY
@media(max-width:992px){
footer .title_links{
    text-align: left;
}
.logo_footer , .site_info{
  margin-bottom: 40px;
}

}

</style>